import type { Project } from "@/stores/worldStore";

function normalizeSubdirectory(subdirectory: string): string {
  return subdirectory.trim().replace(/^[/\\]+/, "").replace(/[/\\]+$/, "");
}

/**
 * Resolve the actual filesystem path for a project.
 * For monorepos this is localPath + subdirectory.
 */
export function resolveProjectPath(project?: Project): string {
  const base = project?.localPath?.trim();
  if (!base) return "";

  const subdirectory = project?.subdirectory ? normalizeSubdirectory(project.subdirectory) : "";
  if (!subdirectory) return base;

  const separator = base.includes("\\") ? "\\" : "/";
  const cleanBase = base.replace(/[\\/]+$/, "");
  const cleanSubdirectory = subdirectory.replace(/[\\/]+/g, separator);
  return `${cleanBase}${separator}${cleanSubdirectory}`;
}

/**
 * Ensure a configured command runs from the project's subdirectory when set.
 */
export function applySubdirectoryToCommand(command: string, project?: Project): string {
  const raw = command.trim();
  if (!raw) return raw;

  const subdirectory = project?.subdirectory ? normalizeSubdirectory(project.subdirectory) : "";
  if (!subdirectory) return raw;

  const quotedSubdirectory = subdirectory.includes(" ")
    ? `"${subdirectory.replace(/"/g, '\\"')}"`
    : subdirectory;

  const lower = raw.toLowerCase();
  if (lower.startsWith("cd ") && lower.includes("&&")) {
    return raw;
  }

  return `cd ${quotedSubdirectory} && ${raw}`;
}
